var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4207 12.8333C13.2463 12.8333 11.4191 11.3461 10.9011 9.33334H2.5874V7H10.9011C11.4191 4.98724 13.2463 3.5 15.4207 3.5C17.9981 3.5 20.0874 5.58934 20.0874 8.16667C20.0874 10.744 17.9981 12.8333 15.4207 12.8333ZM22.4207 9.33334V7H25.9207V9.33334H22.4207ZM9.5874 24.5C7.41292 24.5 5.58581 23.0128 5.06776 21H2.5874V18.6667H5.06776C5.5858 16.6539 7.41292 15.1667 9.5874 15.1667C12.1647 15.1667 14.2541 17.256 14.2541 19.8333C14.2541 22.4107 12.1647 24.5 9.5874 24.5ZM16.5874 18.6667V21H25.9207V18.6667H16.5874ZM11.9207 19.8333C11.9207 21.122 10.8761 22.1667 9.5874 22.1667C8.29874 22.1667 7.25407 21.122 7.25407 19.8333C7.25407 18.5447 8.29874 17.5 9.5874 17.5C10.8761 17.5 11.9207 18.5447 11.9207 19.8333ZM17.7541 8.16667C17.7541 9.45533 16.7094 10.5 15.4207 10.5C14.1321 10.5 13.0874 9.45533 13.0874 8.16667C13.0874 6.878 14.1321 5.83334 15.4207 5.83334C16.7094 5.83334 17.7541 6.878 17.7541 8.16667Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.32d8d7689e97708ea3316816774b6879.svg";
export { ForwardRef as ReactComponent };